import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Checkbox,
  Collapse,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import FolderIcon from '@material-ui/icons/Folder';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import RestaurantMenuIcon from '@material-ui/icons/RestaurantMenu';
import LanguageIcon from '@material-ui/icons/Language';
import DetailButton from '../DetailButton/DetailButton';
import RBISearchButton from '../RBISearchButton/RBISearchButton';
import RBIAvailabilityButton from '../RBIAvailabilityButton/RBIAvailabilityButton';
import styles from './styles';
import { useTranslation } from 'react-i18next';
import { clearPlatforms as clearCategoriesData } from '../../redux/actions/platformsActions';
import { textToSnakeCase } from '../../utils/utils';

const MenuItemsTable = ({
  categories,
  groups,
  showDetailProduct,
  searchObjectPrev,
  handleChangeAutocomplete,
  handleInputChangeAutocomplete,
  handleApplyButton,
  fetchItems,
  groupsCatalog,
  itemsCatalog,
  fetchGroups,
  totalPlatforms,
  loadMorePlatforms,
  loadMoreGroups,
  loadMoreItems,
  handleApply,
  checkSelected,
  clearFlag = false,
  clearSelectedEquipments = flag => { },
  showProductGroupTranslations,
  restaurantId = 0,
  withNormalOptions = true,
  clearFilters = () => { },
}) => {
  const classes = styles();
  const [categoriesOpen, setCategoriesOpen] = useState({});
  const [categoriesCheck, setCategoriesCheck] = useState({});
  const [groupsCheck, setGroupsCheck] = useState({});
  const [itemsCheck, setItemsCheck] = useState({});
  const [masterCheck, setMasterCheck] = useState(false);
  const { thisUser, isRBIConnect } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );
  const { selectedBrand } = useSelector(
    (state: RootStateOrAny) => state.UIReducer,
  );
  const { userInfo } = useSelector(
    (state: RootStateOrAny) => state.UserReducer,
  );
  const dispatch: any = useDispatch();

  const setCategoriesCheckFlag = value => {
    setCategoriesCheck({
      ...categories.reduce((ac, p) => {
        ac[p.categoryId] = value;
        return ac;
      }, {}),
    });
  };

  const setGroupsCheckFlag = value => {
    setGroupsCheck({
      ...Object.keys(groupsCheck).reduce((ac, key) => {
        ac[key] = value;
        return ac;
      }, {}),
    });
  };
  const setItemsCheckFlag = value => {
    setItemsCheck({
      ...Object.keys(itemsCheck).reduce((ac, key) => {
        ac[key] = value;
        return ac;
      }, {}),
    });
  };

  useEffect(() => {
    setCategoriesCheckFlag(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories]);

  const location = useLocation();

  useEffect(() => {
    return () => {
      dispatch(clearCategoriesData());
    };
  }, [dispatch]);

  useEffect(() => {
    let groupsKey = { ...groupsCheck };
    let itemsKey = { ...itemsCheck };
    for (var key of Object.keys(groups)) {
      for (let group of groups[key]) {
        groupsKey[`${group.categoryId}-${group.productGroupId}`] =
          groupsKey[`${group.categoryId}-${group.productGroupId}`] ||
          categoriesCheck[key];
        for (let item of group.items) {
          itemsKey[`${group.categoryId}-${group.productGroupId}-${item.id}`] =
            itemsKey[
            `${group.categoryId}-${group.productGroupId}-${item.id}`
            ] || groupsKey[group.productGroupId];
        }
      }
    }
    setGroupsCheck({ ...groupsKey });
    setItemsCheck({ ...itemsKey });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groups]);

  const handleCheckboxMaster = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMasterCheck(event.target.checked);
    setCategoriesCheck({
      ...Object.keys(categoriesCheck).reduce((ac, key) => {
        ac[key] = event.target.checked;
        return ac;
      }, {}),
    });
    setGroupsCheckFlag(event.target.checked);
    setItemsCheckFlag(event.target.checked);
  };

  const handleCheckboxCategory = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const categoryKeys = {
      ...categoriesCheck,
      [event.target.name]: event.target.checked,
    };
    setCategoriesCheck(categoryKeys);
    setGroupsCheck({
      ...groupsCheck,
      ...groups[event.target.name]?.reduce((ac, g) => {
        ac[`${g.categoryId}-${g.productGroupId}`] = event.target.checked;
        return ac;
      }, {}),
    });
    const itemsKey = {
      ...itemsCheck,
      ...groups[event.target.name]?.reduce((ac, g) => {
        ac = {
          ...ac,
          ...g.items.reduce((ai, i) => {
            ai[`${g.categoryId}-${g.productGroupId}-${i.id}`] =
              event.target.checked;
            return ai;
          }, {}),
        };
        return ac;
      }, {}),
    };

    setItemsCheck({ ...itemsKey });
    if (!event.target.checked) {
      setMasterCheck(event.target.checked);
    } else if (categories.every(p => categoryKeys[p.categoryId])) {
      setMasterCheck(event.target.checked);
    }
  };
  const handleCheckboxGroups = (event: React.ChangeEvent<HTMLInputElement>) => {
    const [categoryId, productGroupId] = event.target.name.split('-');
    const categoryKeys = {
      ...categoriesCheck
    };
    const groupKeys = {
      ...groupsCheck,
      [event.target.name]: event.target.checked,
    };
    const itemsKey = {
      ...itemsCheck,
      ...groups[event.target.value]
        .find(g => g.productGroupId === +productGroupId)
        .items.reduce((ai, i) => {
          ai[`${categoryId}-${productGroupId}-${i.id}`] = event.target.checked;
          return ai;
        }, {}),
    };
    setGroupsCheck({ ...groupKeys });
    setItemsCheck({ ...itemsKey });
    if (allItemsChecked(groupKeys, categoryId)) {
      categoryKeys[categoryId] = event.target.checked;
      setCategoriesCheck({ ...categoryKeys });
    }
    if (!event.target.checked) {
      setCategoriesCheck({
        ...categoriesCheck,
        [categoryId]: event.target.checked,
      });
      setMasterCheck(event.target.checked);
    } else if (groups[categoryId]?.every(g => groupKeys[g.productGroupId])) {
      categoryKeys[categoryId] = event.target.checked;
      setCategoriesCheck(categoryKeys);
      if (categories.every(p => categoryKeys[p.categoryId])) {
        setMasterCheck(event.target.checked);
      }
    }
  };
  const handleCheckboxItems = (event: React.ChangeEvent<HTMLInputElement>) => {
    const [categoryId, productGroupId] = event.target.value.split('-');
    const itemsKey = {
      ...itemsCheck,
      [event.target.name]: event.target.checked,
    };
    const groupKeys = {
      ...groupsCheck,
    }
    setItemsCheck({
      ...itemsKey,
    });

    if (!event.target.checked) {
      setCategoriesCheck({
        ...categoriesCheck,
        [categoryId]: event.target.checked,
      });
      setGroupsCheck({
        ...groupsCheck,
        [`${categoryId}-${productGroupId}`]: event.target.checked,
      });
      setMasterCheck(event.target.checked);
    } else if (
      groups[categoryId]
        .find(g => g.productGroupId === +productGroupId)
        .items?.every(i => itemsKey[i.id])
    ) {
      groupKeys[`${categoryId}-${productGroupId}`] = event.target.checked;
      setGroupsCheck(groupKeys);
      if (groups[categoryId]?.every(g => groupKeys[g.productGroupId])) {
        const categoryKeys = {
          ...categoriesCheck,
          [categoryId]: event.target.checked,
        };
        setCategoriesCheck(categoryKeys);
        if (categories.every(p => categoryKeys[p.categoryId])) {
          setMasterCheck(event.target.checked);
        }
      }
    }
  };
  const onOpenClick = id => () => {
    setCategoriesOpen({ ...categoriesOpen, [id]: !categoriesOpen[id] });
    if (!categoriesOpen[id] && !groups[id]?.length) {
      fetchGroups(id);
    }
  };

  const clearCategories = () => {
    clearFilters();
    let copyCategoriesOpen = { ...categoriesOpen };
    Object.keys(categoriesOpen).forEach(key => {
      copyCategoriesOpen[key] = false;
    });
    setCategoriesOpen({ ...copyCategoriesOpen });
    setCategoriesCheckFlag(false);
  };

  const allItemsChecked = (obj, id) => {
    let keys = Object.keys(obj).filter(word => word.includes(id));
    if (keys.length > 0) {
      for (let key of keys) {
        if (obj[key] !== true)
          return false
      }
      return true;
    }
    return false;
  }

  const [groupsOpen, setGroupsOpen] = useState({});
  const onOpenClickGroups = (idGroup, idCategory) => () => {
    setGroupsOpen({
      ...groupsOpen,
      [`${idCategory}-${idGroup}`]: !groupsOpen[`${idCategory}-${idGroup}`],
    });
    if (
      !groupsOpen[`${idCategory}-${idGroup}`] &&
      !groups[idCategory].find(g => g.productGroupId === +idGroup).items.length
    ) {
      fetchItems(idGroup, idCategory);
    }
  };

  useEffect(() => {
    if (masterCheck) {
      checkSelected({ categories: categories.map(p => p.categoryId) });
    } else {
      let categoriesChecked: any[] = [];
      let groupsChecked: any[] = [];
      let itemsChecked: any[] = [];
      categories.forEach(p => {
        if (categoriesCheck[p.categoryId] && (!Array.isArray(groups) || groups[p.categoryId]?.length > 1)) {
          categoriesChecked.push(Number(p.categoryId));
        } else {
          groups[p.categoryId]?.forEach(g => {
            if (groupsCheck[`${p.categoryId}-${g.productGroupId}`]) {
              groupsChecked.push({
                groupId: Number(g.productGroupId),
                categoryId: Number(g.categoryId),
              });
            } else {
              g.items.forEach(i => {
                if (itemsCheck[`${p.categoryId}-${g.productGroupId}-${i.id}`]) {
                  itemsChecked.push(Number(i.id));
                }
              });
            }
          });
        }
      });
      checkSelected({
        categories: categoriesChecked,
        groups: groupsChecked,
        menu_items: itemsChecked,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupsCheck, categoriesCheck, itemsCheck]);

  useEffect(() => {
    if (clearFlag) {
      setMasterCheck(false);
      setCategoriesCheckFlag(false);
      setGroupsCheckFlag(false);
      setItemsCheckFlag(false);
      clearSelectedEquipments(false);
      setCategoriesOpen({});
      setGroupsOpen({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearFlag]);

  const { t } = useTranslation();

  return (
    <TableContainer style={{ minHeight: '64vh' }}>
      <Table
        stickyHeader
        aria-label="sticky table"
        size="small"
        padding="none"
        style={{ minHeight: '17vh' }}
      >
        <TableHead>
          <TableRow>
            {restaurantId ? (
              ''
            ) : (
              <TableCell
                className={classes.columnWidthCheckboxes}
                key="checkBoxAll"
                align="left"
              >
                <Checkbox
                  checked={masterCheck}
                  onChange={handleCheckboxMaster}
                  inputProps={{ 'aria-label': 'select all groups' }}
                  disabled={!categories?.length}
                />
              </TableCell>
            )}
            <TableCell className={classes.divFilters}>
              {restaurantId || !withNormalOptions ? (
                ''
              ) : (
                <div style={{ marginTop: 10 }}>
                  <RBIAvailabilityButton
                    textButton={t('app.common.filter')}
                    onApply={handleApplyButton}
                  />
                </div>
              )}
              <RBISearchButton
                id={'group'}
                valueOption={searchObjectPrev['group']}
                labelText={t('productGroups.productGroup')}
                onChangeInput={handleInputChangeAutocomplete}
                onChange={handleChangeAutocomplete}
                handleApplyButton={handleApplyButton}
                options={groupsCatalog}
                textButton={t('app.common.filter')}
              />
              <RBISearchButton
                id={'item'}
                valueOption={searchObjectPrev['item']}
                labelText={t('productGroups.menuItem')}
                onChange={handleChangeAutocomplete}
                onChangeInput={handleInputChangeAutocomplete}
                handleApplyButton={handleApplyButton}
                options={itemsCatalog}
                textButton={t('app.common.filter')}
              />
              {!withNormalOptions && (
                <div className={classes.flexColumnCenter}>
                  <Button
                    onClick={clearCategories}
                    variant="contained"
                    color="primary"
                    size="small"
                  >
                    {t('restaurant.list.gridLabels.clearBtn')}
                  </Button>
                </div>
              )}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {categories?.length && categoriesOpen ? (
            categories.map((category, indexPlatform) => {
              let row = [
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={`row_${category.categoryId}`}
                >
                  {restaurantId ? null : (
                    <TableCell>
                      <Checkbox
                        checked={
                          categoriesCheck[category.categoryId] || masterCheck
                        }
                        onChange={handleCheckboxCategory}
                        inputProps={{ 'aria-label': 'select all groups' }}
                        name={category.categoryId.toString()}
                      />
                    </TableCell>
                  )}
                  <TableCell>
                    <IconButton
                      aria-label="expand row"
                      size="small"
                      onClick={onOpenClick(category.categoryId)}
                    >
                      {!categoriesOpen[category.categoryId] ? (
                        <ChevronRightIcon />
                      ) : (
                        <KeyboardArrowDownIcon />
                      )}
                    </IconButton>
                    <FolderIcon className={classes.icons} />
                    {`${t(`app.menu_items.${textToSnakeCase(category.category)}`, category.category)}(${category.productGroups})`}
                  </TableCell>
                </TableRow>,
              ];
              if (
                groups[category.categoryId] &&
                categoriesOpen[category.categoryId]
              ) {
                row.push(
                  groups[category.categoryId].map((group, indexGroup) => {
                    let rowGroup = [
                      <TableRow key={indexGroup}>
                        {restaurantId ? null : (
                          <TableCell
                            className={`${!categoriesOpen[category.categoryId]
                                ? classes.borderBottom
                                : ''
                              }`}
                          >
                            <Collapse
                              in={categoriesOpen[category.categoryId]}
                              timeout="auto"
                            >
                              <Checkbox
                                checked={
                                  !!groupsCheck[
                                  `${group.categoryId}-${group.productGroupId}`
                                  ]
                                }
                                name={`${group.categoryId}-${group.productGroupId}`}
                                onChange={handleCheckboxGroups}
                                inputProps={{
                                  'aria-label': 'select all groups',
                                  value: category.categoryId,
                                }}
                              />
                            </Collapse>
                          </TableCell>
                        )}
                        <TableCell
                          className={`${!categoriesOpen[category.categoryId]
                              ? classes.borderBottom
                              : ''
                            }`}
                        >
                          <Collapse
                            in={categoriesOpen[category.categoryId]}
                            timeout="auto"
                            className={classes.divGroups}
                          >
                            <div>
                              <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={onOpenClickGroups(
                                  group.productGroupId,
                                  category.categoryId,
                                )}
                              >
                                {!groupsOpen[
                                  `${group.categoryId}-${group.productGroupId}`
                                ] ? (
                                  <ChevronRightIcon />
                                ) : (
                                  <KeyboardArrowDownIcon />
                                )}
                              </IconButton>
                              <GroupWorkIcon className={classes.icons} />
                              {`${group.productGroup}(${group.menuItems})`}

                              {thisUser.hasCreateTranslationsMultilanguage &&
                                withNormalOptions && (
                                  <IconButton
                                    data-testid="menu-items-table-icon-button"
                                    className={classes.floatRight}
                                    onClick={showProductGroupTranslations(
                                      category,
                                      group,
                                    )}
                                  >
                                    <LanguageIcon />
                                  </IconButton>
                                )}
                            </div>
                          </Collapse>
                        </TableCell>
                      </TableRow>,
                    ];
                    if (group.items.length) {
                      rowGroup.push(
                        group.items.map((item, indexItem) => {
                          if (groupsCheck[`${group.categoryId}-${group.productGroupId}`]) {
                            itemsCheck[`${group.categoryId}-${group.productGroupId}-${item.id}`] = true;
                          }
                          let itemsRow = [
                            <TableRow key={indexItem}>
                              {restaurantId ? (
                                ''
                              ) : (
                                <TableCell
                                  className={`${!categoriesOpen[category.categoryId] ||
                                      !groupsOpen[
                                      `${group.categoryId}-${group.productGroupId}`
                                      ]
                                      ? classes.borderBottom
                                      : ''
                                    }`}
                                >
                                  <Collapse
                                    in={
                                      categoriesOpen[category.categoryId] &&
                                      groupsOpen[
                                      `${group.categoryId}-${group.productGroupId}`
                                      ]
                                    }
                                    timeout="auto"
                                  >
                                    <Checkbox
                                      checked={
                                        !!itemsCheck[
                                        `${group.categoryId}-${group.productGroupId}-${item.id}`
                                        ]
                                      }
                                      name={`${group.categoryId}-${group.productGroupId}-${item.id}`}
                                      onChange={handleCheckboxItems}
                                      inputProps={{
                                        'aria-label': 'select all items',
                                        value: `${category.categoryId}-${group.productGroupId}`,
                                      }}
                                    />
                                  </Collapse>
                                </TableCell>
                              )}
                              <TableCell
                                className={`${!categoriesOpen[category.categoryId] ||
                                    !groupsOpen[
                                    `${group.categoryId}-${group.productGroupId}`
                                    ]
                                    ? classes.borderBottom
                                    : ''
                                  }`}
                              >
                                <Collapse
                                  in={
                                    categoriesOpen[category.categoryId] &&
                                    groupsOpen[
                                    `${group.categoryId}-${group.productGroupId}`
                                    ]
                                  }
                                  timeout="auto"
                                >
                                  <div className={classes.divItems}>
                                    <div>
                                      <RestaurantMenuIcon
                                        className={classes.icons}
                                      />{' '}
                                      {item.name}
                                    </div>
                                    {(thisUser.hasViewMenuItemDetails ||
                                      thisUser.hasViewMenuItemListAndDetails ||
                                      thisUser.hasSearchMenuItem) &&
                                      location.pathname !== '/products' ? (
                                      withNormalOptions ? (
                                        <DetailButton
                                          callbackFunction={showDetailProduct(
                                            category.categoryId,
                                            group.productGroupId,
                                            item.id,
                                          )}
                                        />
                                      ) : null
                                    ) : (
                                      (thisUser.hasViewMenuItemListAndDetails ||
                                        thisUser.hasViewMenuItemList) && (
                                        <DetailButton
                                          callbackFunction={showDetailProduct(
                                            category.categoryId,
                                            group.productGroupId,
                                            item.id,
                                          )}
                                        />
                                      )
                                    )}
                                  </div>
                                </Collapse>
                              </TableCell>
                            </TableRow>,
                          ];
                          if (
                            group.items.length === indexItem + 1 &&
                            group.menuItems > group.items.length
                          ) {
                            itemsRow.push(
                              <TableRow
                                hover
                                tabIndex={-1}
                                key={`row_items_more`}
                              >
                                <TableCell colSpan={2} align="center">
                                  <Collapse
                                    in={
                                      categoriesOpen[category.categoryId] &&
                                      groupsOpen[
                                      `${group.categoryId}-${group.productGroupId}`
                                      ]
                                    }
                                    timeout="auto"
                                  >
                                    <Button
                                      onClick={loadMoreItems(
                                        category.categoryId,
                                        group.productGroupId,
                                        Math.ceil(group.items.length / 100),
                                      )}
                                    >
                                      {t('productGroups.loadMoreItems')}
                                    </Button>
                                  </Collapse>
                                </TableCell>
                              </TableRow>,
                            );
                          }
                          return itemsRow;
                        }),
                      );
                    }
                    if (
                      groups[category.categoryId].length === indexGroup + 1 &&
                      category.productGroups >
                      groups[category.categoryId].length
                    ) {
                      rowGroup.push(
                        <TableRow hover tabIndex={-1} key={`row_groups_more`}>
                          <TableCell colSpan={2} align="center">
                            <Collapse
                              in={categoriesOpen[category.categoryId]}
                              timeout="auto"
                            >
                              <Button
                                onClick={loadMoreGroups(
                                  category.categoryId,
                                  Math.ceil(
                                    groups[category.categoryId].length / 100,
                                  ),
                                )}
                              >
                                {t('productGroups.loadMoreGroups')}
                              </Button>
                            </Collapse>
                          </TableCell>
                        </TableRow>,
                      );
                    }
                    return rowGroup;
                  }),
                );
              }
              if (
                indexPlatform === categories.length - 1 &&
                indexPlatform < totalPlatforms - 1
              ) {
                row.push(
                  <TableRow hover tabIndex={-1} key={`row_platform_more`}>
                    <TableCell colSpan={2} align="center">
                      <Button onClick={loadMorePlatforms}>
                        {t('productGroups.loadMoreCategories')}
                      </Button>
                    </TableCell>
                  </TableRow>,
                );
              }
              return row;
            })
          ) : (
            <TableRow>
              <TableCell colSpan={42}>
                <div style={{ textAlign: 'center' }}>
                  <Typography>{t('productGroups.noMenuItemsFound')}</Typography>
                </div>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MenuItemsTable;
